export const ApplicationConstant = {
    ApplicationID : 19,
    clientId : 12,
    DEFAULT_DATE_FORMAT: 'YYYY-MM-DD'
};
